import type { AuthSession } from '@/lib/authToken'
import type { CgtUser } from '@/types/cgt'

/**
 * The renderer's `CgtUser` for the signed-in principal.
 *
 * Every page that hosts a form used to pass a hardcoded "Demo User" here, and
 * because the browser built the signature value from it, that is the name
 * signatures were stamped with. The server now stamps signatures itself, so
 * this is only what the dialogs DISPLAY ("Signing as …") and the id "Sign as"
 * compares against — but it has to be the real person for either to be true.
 *
 * `groups` is the legacy free-text group check, which nothing enforced and the
 * renderer no longer reads; signer groups are server-side (z8nrz7dt45).
 */
export function cgtUserFrom(session: AuthSession | null, email: string | null): CgtUser {
  return {
    id: session?.userId ?? '',
    name: session?.fullName?.trim() || session?.email || email || 'Signed-in user',
    groups: [],
  }
}
